module.exports = __webpack_public_path__ + "img/img_map_1.2929b7e4.png";